// GPU monitoring API client.

import { ApiError } from './client'

export interface GPUStats {
  name: string
  temperature_c: number
  utilization_gpu_pct: number
  utilization_memory_pct: number
  memory_used_mb: number
  memory_total_mb: number
  power_draw_w: number
  power_limit_w: number
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
  })
  if (res.status === 401) {
    if (!location.pathname.startsWith('/login')) {
      window.location.href = '/login'
    }
    throw new ApiError(401, 'unauthorized')
  }
  if (!res.ok) {
    const body = await res.json().catch(() => null)
    throw new ApiError(
      res.status,
      (body as { error?: string } | null)?.error ?? res.statusText,
      body,
    )
  }
  if (res.status === 204) return undefined as T
  return (await res.json()) as T
}

export const gpuApi = {
  stats: () => request<GPUStats>('/api/admin/gpu/stats'),
}
